import React from 'react'
import styles from './TableBodyQ.module.css'
import t from '../../../utils/translation'

export default function TableBodyQ({children, withoutPagination}) {
  return (
    <div className={withoutPagination ? styles.columnContentScroll : styles.tbody}>{ React.Children.count(children) > 0 ? children : <p className={styles.noResult}>{t("EmptyTableText")}</p>}</div>
  )
}
